import { IProductSettings } from "../../../products/repository/IProductSettings";

export const getSinglePromo = (payload: IProductSettings, name?: string) => ({
  type: "@saga/GET_SINGLE_PROMO",
  payload: { payload, name },
});
